import Grid from '@material-ui/core/Grid';
import GridFormField from 'shared/components/GridFormField';
import React from 'react';
import removeHTML from 'shared/utils/removeHTML';
import Typography from '@material-ui/core/Typography';
import {
	dateInRange,
	isAfterDob,
	isAfterDateInField,
	isBeforeDateInField,
	maxStrLength,
	settingValidation,
	isValidDate,
	zipPostalValidation,
} from 'shared/utils/validations';
import { formatZipPostal, normalizeZipPostal } from 'shared/utils/formatting';
import { FormSection } from 'redux-form';
import { PropTypes } from 'prop-types';
import {
	DATE_RANGE_START_YEAR,
	DATE_RANGE_START_MONTH,
	DATE_RANGE_START_DAY,
	PREVIOUS_RESIDENCE,
	STATES,
} from './constants';

// eslint-disable-next-line class-methods-use-this
function formatZipPostalField(value) {
	return formatZipPostal(value);
}

// eslint-disable-next-line class-methods-use-this
function normalizeZipPostalField(value) {
	return normalizeZipPostal(value);
}

const PreviousResidenceFields = ({ disableAll, settings, name }) => (
	<FormSection name={name} style={{ width: '100%' }}>
		<Grid container spacing={5}>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousAddress1Label}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousAddress1Description}
				fieldSettings={settings.primary.previousAddress1}
				name="address1"
				validation={[settingValidation(settings.primary.previousAddress1), maxStrLength(30)]}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousAddress2Label}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousAddress2Description}
				fieldSettings={settings.primary.previousAddress2}
				name="address2"
				validation={[settingValidation(settings.primary.previousAddress2), maxStrLength(30)]}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousCityLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousCityDescription}
				fieldSettings={settings.primary.previousCity}
				name="city"
				validation={[settingValidation(settings.primary.previousCity), maxStrLength(30)]}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousStateLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousStateDescription}
				fieldSettings={settings.primary.previousState}
				select
				menuOptions={STATES}
				name="state"
				validation={settingValidation(settings.primary.previousState)}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousPostalLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousPostalDescription}
				fieldSettings={settings.primary.previousZip}
				name="zipCode"
				validation={[
					zipPostalValidation,
					settingValidation(settings.primary.previousZip),
					maxStrLength(10),
				]}
				format={formatZipPostalField}
				normalize={normalizeZipPostalField}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousResidenceStartLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousResidenceStartDescription}
				fieldSettings={settings.primary.previousTimeAtResidence}
				type="date"
				inputProps={{ 
					style: { textTransform: 'uppercase', marginTop: '16px' },
					placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="previousAddressTermStart"
				validation={[
					settingValidation(settings.primary.previousTimeAtResidence),
					isValidDate,
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isBeforeDateInField(`${name}.previousAddressTermEnd`),
					isAfterDob,
				]}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousResidenceEndLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousResidenceEndDescription}
				fieldSettings={settings.primary.previousTimeAtResidence}
				type="date"
				inputProps={{ 
					style: { textTransform: 'uppercase', marginTop: '16px' }, 
					placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="previousAddressTermEnd"
				validation={[
					settingValidation(settings.primary.previousTimeAtResidence),
					isValidDate,
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isAfterDateInField(`${name}.previousAddressTermStart`),
				]}
				disabled={disableAll}
			/>
		</Grid>
		<Typography type="caption" component="div" style={{ paddingTop: '20px' }}>
			<div
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: removeHTML(settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousResidenceFooter),
				}}
			/>
		</Typography>
	</FormSection>
);

PreviousResidenceFields.propTypes = {
	disableAll: PropTypes.bool,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
	}),
	name: PropTypes.string,
};

PreviousResidenceFields.defaultProps = {
	disableAll: false,
	settings: {},
	name: PREVIOUS_RESIDENCE,
};

export default PreviousResidenceFields;
